import { Tag } from "@carbon/react";
import { OverflowMenuVertical } from "@carbon/react/icons";

import { transactionStatus, transactionType } from "../../enums";
import { formatAsCurrency } from "../../utils";

export const transactionDisplayFormatter = (item) => {
  const statusIndicator =
    item.status === transactionStatus.failed
      ? { statusText: "failed", statusType: "red" }
      : item.status === transactionStatus.successful
      ? { statusText: "successful", statusType: "green" }
      : { statusText: "refunded", statusType: "gray" };

  const txTypeString = transactionType[item.transactionType];

  return {
    ...item,
    amount: (
      <strong>
        {item.currency_symbol} {formatAsCurrency(item.amount)}
      </strong>
    ),
    status: (
      <Tag className="transaction-status" type={statusIndicator.statusType}>
        <span>{statusIndicator.statusText}</span>
        <div
          style={{ backgroundColor: statusIndicator.statusType }}
          className="status-indicator"
        />
      </Tag>
    ),
    description: <strong>{item.description}</strong>,
    customer: item.customer.email,
    transactionType: txTypeString.replace(/^./, txTypeString[0].toUpperCase()),
    gateway: (
      <img
        src={`${process.env.PUBLIC_URL}/${item.gateway_logo_url}`}
        alt="gateway logo"
      />
    ),
    date: <span className="date--oneline">{item.date}</span>,
    // more: <OverflowMenuVertical />,
  };
};
